import { render, staticRenderFns } from "./BalancoPatrimonialFormulaPerfil.vue?vue&type=template&id=f0c91c92"
import script from "./BalancoPatrimonialFormulaPerfil.vue?vue&type=script&lang=js"
export * from "./BalancoPatrimonialFormulaPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports